const About = () => {
  return (
    <div className="about pt-5 pb-5">
      <h3>About the Career Counsellor</h3>
      <p className="pt-3 mb-2">
        John Doe is a young professional who is passionate about helping people
        and saving lives. He yearns always to impacting lives positively in one
        way or the other. He believes in women empowerment which is a key for
        development.
      </p>
      <span className="badge bg-dark mt-0 me-2">Computer Engineering</span>
      <span className="badge bg-dark mt-0">Dean's Honors List</span>
    </div>
  );
};

export default About;
